import React from 'react';
// import { useTranslation } from 'react-i18next';
import { UtilityAccordion } from '../../UtilityAccordion';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
export const ProviderSetupModalContent = observer(_ref => {
  var _store$addNewProperty;
  let handleConfigChange = _ref.handleConfigChange,
    isNew = _ref.isNew,
    isEdit = _ref.isEdit,
    isDetailsPage = _ref.isDetailsPage,
    isNewUtility = _ref.isNewUtility,
    propertyId = _ref.propertyId,
    hideSaved = _ref.hideSaved;
  // const { t } = useTranslation();
  const store = useStore();
  return /*#__PURE__*/React.createElement(React.Fragment, null, (_store$addNewProperty = store.addNewProperty.utilitiesSetupV2.getUtilityConfigurator) === null || _store$addNewProperty === void 0 ? void 0 : _store$addNewProperty.utilities.map(utility => {
    var _store$addNewProperty2;
    if (hideSaved && ((_store$addNewProperty2 = store.addNewProperty.utilitiesSetupV2.selectedUtilities) === null || _store$addNewProperty2 === void 0 ? void 0 : _store$addNewProperty2.findIndex(i => i.utilityId === utility.id)) !== -1) return;
    return /*#__PURE__*/React.createElement(UtilityAccordion, {
      utility: utility,
      key: "ProviderSetupModalContentKey-".concat(utility.id || utility.utilityTypeId),
      id: "ProviderSetupModalContentID-".concat(utility.id || utility.utilityTypeId),
      handleConfigChange: handleConfigChange,
      isNew: isNew,
      isEdit: isEdit,
      isDetailsPage: isDetailsPage,
      isNewUtility: isNewUtility,
      hideNotEnabled: false,
      propertyId: propertyId
    });
  }));
});